webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(54);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(48);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 12:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CubeCore = __webpack_require__(50);
	
	var _CubeCore2 = _interopRequireDefault(_CubeCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    CubeCore: _CubeCore2.default
	  }
	};

/***/ },

/***/ 13:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function myBrowser() {
	  var userAgent = navigator.userAgent;
	  var isOpera = userAgent.indexOf('Opera') > -1;
	  if (isOpera) {
	    return 'Opera';
	  }
	  if (userAgent.indexOf('Firefox') > -1) {
	    return 'FF';
	  }
	  if (userAgent.indexOf('Chrome') > -1) {
	    return 'Chrome';
	  }
	  if (userAgent.indexOf('Safari') > -1) {
	    return 'Safari';
	  }
	  if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
	    return 'IE';
	  }
	  return 'none';
	}
	exports.default = {
	  props: ['position', 'opacity'],
	  data: function data() {
	    return {
	      x: 0,
	      y: 0,
	      z: 0,
	      rotateX: 0,
	      rotateY: 0,
	      rotateZ: 0,
	      color: {
	        x1: '',
	        x3: '',
	        y1: '',
	        y3: '',
	        z1: '',
	        z3: ''
	      },
	      colorCache: {}
	    };
	  },
	  mounted: function mounted() {
	    this.x = this.position[0];
	    this.y = this.position[1];
	    this.z = this.position[2];
	    if (this.position[1] == 1) {
	      this.color.y1 = '#0500c1';
	    } else if (this.position[1] == 3) {
	      this.color.y3 = '#138804';
	    }
	    if (this.position[2] == 1) {
	      this.color.z1 = '#f7f8f5';
	    } else if (this.position[2] == 3) {
	      this.color.z3 = '#f9fd0c';
	    }
	    if (this.position[0] == 1) {
	      this.color.x1 = '#f9640a';
	    } else if (this.position[0] == 3) {
	      this.color.x3 = '#c50209';
	    }
	  },
	
	  computed: {
	    styleObject: function styleObject() {
	      var transform = '';
	      var transformOrigin = '';
	      if (this.position[1] == 1) {
	        transform = 'translateX(-1.1em)';
	        transformOrigin = '1.6em';
	      } else if (this.position[1] == 3) {
	        transform = 'translateX(1.1em)';
	        transformOrigin = '-.6em';
	      } else if (this.position[1] == 2) {
	        transform = 'translateX(-0em)';
	        transformOrigin = '0.5em';
	      }
	      if (this.position[2] == 1) {
	        transform += ' translateY(1.1em)';
	        transformOrigin += ' -0.6em';
	      } else if (this.position[2] == 3) {
	        transform += ' translateY(-1.1em)';
	        transformOrigin += ' 1.6em';
	      } else if (this.position[2] == 2) {
	        transform += ' translateY(-0em)';
	        transformOrigin += ' 0.5em';
	      }
	      var mb = myBrowser();
	      if (this.position[0] == 1) {
	        if (mb == 'Safari') {
	          transform += ' translateZ(0em)';
	        } else {
	          transform += ' translateZ(-1.1em)';
	        }
	        transformOrigin += ' 1.1em';
	      } else if (this.position[0] == 3) {
	        if (mb == 'Safari') {
	          transform += ' translateZ(0em)';
	        } else {
	          transform += ' translateZ(1.1em)';
	        }
	        transformOrigin += ' -1.1em';
	      } else if (this.position[0] == 2) {
	        transform += ' translateZ(-0em)';
	        transformOrigin += ' 0em';
	      }
	      transform += ' rotateX(' + this.rotateX * 90 + 'deg) rotateY(' + this.rotateY * 90 + 'deg) rotateZ(' + this.rotateZ * 90 + 'deg)';
	      return {
	        transform: transform,
	        transformOrigin: transformOrigin
	      };
	    }
	  }
	};

/***/ },

/***/ 14:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(17);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Cube = __webpack_require__(49);
	
	var _Cube2 = _interopRequireDefault(_Cube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var positions = [];
	for (var x = 1; x < 4; x++) {
	  for (var y = 1; y < 4; y++) {
	    for (var z = 1; z < 4; z++) {
	      positions.push([x, y, z]);
	    }
	  }
	}
	
	function generateRandomRotateParams(last) {
	  var param = {
	    direction: '',
	    clockwise: 0
	  };
	
	  var isReserve = function isReserve(lhs, rhs) {
	    return lhs.direction === rhs.direction && lhs.clockwise + rhs.clockwise === 0;
	  };
	
	  var directions = ['r', 'u', 'b', 'f', 'd', 'l'];
	  param.direction = directions[Math.floor(Math.random() * 6)];
	  var clockwises = [-1, 1];
	  param.clockwise = clockwises[Math.floor(Math.random() * 2)];
	
	  if (last !== undefined) {
	    if (isReserve(param, last)) {
	      return generateRandomRotateParams(last);
	    }
	  }
	
	  return param;
	}
	
	exports.default = {
	  name: 'CubeCore',
	  data: function data() {
	    return {
	      title: 'Rubik Cube',
	      rotateX: -35,
	      rotateY: -45,
	      rotateing: false,
	      looping: false,
	      opacity: 100,
	      positions: positions
	    };
	  },
	
	  methods: {
	    rotate: function rotate(direction, clockwise, callback, isnotclick) {
	      var _this = this;
	
	      if (this.looping && !isnotclick) {
	        return;
	      }
	      if (this.rotateing) {
	        return;
	      }
	      var coordinate = '';
	      var position = 0;
	      switch (direction) {
	        case 'r':
	          coordinate = 'y';
	          position = 3;
	          break;
	        case 'u':
	          coordinate = 'z';
	          position = 3;
	          break;
	        case 'l':
	          coordinate = 'y';
	          position = 1;
	          break;
	        case 'd':
	          coordinate = 'z';
	          position = 1;
	          break;
	        case 'f':
	          coordinate = 'x';
	          position = 3;
	          break;
	        case 'b':
	          coordinate = 'x';
	          position = 1;
	          break;
	        default:
	          console.log('error direction');
	      }
	      this.rotateing = true;
	      var list = this.$children.filter(function (item) {
	        return item[coordinate] == position;
	      });
	      list.forEach(function (item) {
	        (0, _assign2.default)(item.colorCache, item.color);
	        item.$el.style.transition = 'all .5s ease-in-out';
	        if (coordinate == 'y') {
	          item.rotateX += clockwise;
	        } else if (coordinate == 'x') {
	          item.rotateZ += clockwise;
	        } else if (coordinate == 'z') {
	          item.rotateY += clockwise;
	        }
	      });
	      setTimeout(function () {
	        list.forEach(function (item) {
	          item.$el.style.transition = 'none';
	          if (coordinate == 'y') {
	            item.rotateX = 0;
	            if (clockwise == 1) {
	              _this.changeColor(_this.$refs[_this.transpose(item.z) + '-' + item.y + '-' + item.x][0], item, 'x', 'z', 'y');
	            } else {
	              _this.changeColor(_this.$refs[item.z + '-' + item.y + '-' + _this.transpose(item.x)][0], item, 'z', 'x', 'y');
	            }
	          } else if (coordinate == 'x') {
	            item.rotateZ = 0;
	            if (clockwise == 1) {
	              _this.changeColor(_this.$refs[item.x + '-' + item.z + '-' + _this.transpose(item.y)][0], item, 'z', 'y', 'x');
	            } else {
	              _this.changeColor(_this.$refs[item.x + '-' + _this.transpose(item.z) + '-' + item.y][0], item, 'y', 'z', 'x');
	            }
	          } else if (coordinate == 'z') {
	            item.rotateY = 0;
	            if (clockwise == 1) {
	              _this.changeColor(_this.$refs[_this.transpose(item.y) + '-' + item.x + '-' + item.z][0], item, 'x', 'y', 'z');
	            } else {
	              _this.changeColor(_this.$refs[item.y + '-' + _this.transpose(item.x) + '-' + item.z][0], item, 'y', 'x', 'z');
	            }
	          }
	        });
	        _this.rotateing = false;
	        if (callback) {
	          setTimeout(function () {
	            callback();
	          }, 120);
	        }
	      }, 500);
	    },
	    changeColor: function changeColor(c1, c2, d1, d2, d3) {
	      var _c1$color;
	
	      c1.color = (_c1$color = {}, (0, _defineProperty3.default)(_c1$color, d1 + '1', c2.colorCache[d2 + '3']), (0, _defineProperty3.default)(_c1$color, d1 + '3', c2.colorCache[d2 + '1']), (0, _defineProperty3.default)(_c1$color, d2 + '3', c2.colorCache[d1 + '3']), (0, _defineProperty3.default)(_c1$color, d2 + '1', c2.colorCache[d1 + '1']), (0, _defineProperty3.default)(_c1$color, d3 + '1', c2.colorCache[d3 + '1']), (0, _defineProperty3.default)(_c1$color, d3 + '3', c2.colorCache[d3 + '3']), _c1$color);
	    },
	    transpose: function transpose(x) {
	      if (x == 1) {
	        return 3;
	      } else if (x == 3) {
	        return 1;
	      }
	      return 2;
	    },
	    handleMouseDown: function handleMouseDown(e) {
	      var _this2 = this;
	
	      this.dragging = true;
	      var firstX = e.clientX;
	      var firstY = e.clientY;
	      var handleMouseMove = function handleMouseMove(event) {
	        _this2.rotateY += (event.clientX - firstX) * 0.5;
	        _this2.rotateX -= (event.clientY - firstY) * 0.5;
	        firstX = event.clientX;
	        firstY = event.clientY;
	      };
	      var handleMouseUp = function handleMouseUp() {
	        if (_this2.dragging) {
	          _this2.dragging = false;
	        }
	        document.removeEventListener('mousemove', handleMouseMove);
	        document.removeEventListener('mouseup', handleMouseUp);
	      };
	
	      document.addEventListener('mousemove', handleMouseMove);
	      document.addEventListener('mouseup', handleMouseUp);
	    },
	    randomRotate: function randomRotate(loopNum, isClick, lastParam) {
	      if (this.looping && isClick || this.rotateing) {
	        return;
	      }
	      if (loopNum <= 0) {
	        this.looping = false;
	        return;
	      }
	      this.looping = true;
	      var param = generateRandomRotateParams(lastParam);
	
	      this.rotate(param.direction, param.clockwise, this.randomRotate.bind(this, loopNum - 1, false, param), true);
	    }
	  },
	  components: {
	    Cube: _Cube2.default
	  }
	};

/***/ },

/***/ 45:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 46:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 47:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 48:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(47)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 49:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(46)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 50:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(45)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 51:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "hello",
	    on: {
	      "mousedown": _vm.handleMouseDown
	    }
	  }, [_h('h1', [_vm._s(_vm.title)]), " ", _h('div', {
	    staticClass: "button-group"
	  }, [_h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('r', 1)
	      }
	    }
	  }, ["R"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('r', -1)
	      }
	    }
	  }, ["R'"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('u', -1)
	      }
	    }
	  }, ["U"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('u', 1)
	      }
	    }
	  }, ["U'"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('b', 1)
	      }
	    }
	  }, ["B'"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('b', -1)
	      }
	    }
	  }, ["B"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('f', -1)
	      }
	    }
	  }, ["F'"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('f', 1)
	      }
	    }
	  }, ["F"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('d', 1)
	      }
	    }
	  }, ["D"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('d', -1)
	      }
	    }
	  }, ["D'"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('l', 1)
	      }
	    }
	  }, ["L'"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.rotate('l', -1)
	      }
	    }
	  }, ["L"]), " ", _h('div', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.randomRotate(25, true)
	      }
	    }
	  }, ["随机打乱"])]), " ", _h('div', {
	    staticClass: "opacity-set"
	  }, [_h('label', ["透明度"]), " ", _h('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.opacity),
	      expression: "opacity"
	    }],
	    attrs: {
	      "type": "range",
	      "min": "0",
	      "max": "100"
	    },
	    domProps: {
	      "value": _vm._s(_vm.opacity)
	    },
	    on: {
	      "mousemove": function($event) {
	        $event.stopPropagation();
	        (function() {})
	      },
	      "input": function($event) {
	        _vm.opacity = $event.target.value
	      }
	    }
	  })]), " ", _h('div', {
	    staticClass: "cube",
	    style: ('transform: rotateX(' + _vm.rotateX + 'deg) rotateY(' + _vm.rotateY + 'deg)')
	  }, [_vm._l((_vm.positions), function(position) {
	    return _h('Cube', {
	      key: position[0] + '-' + position[1] + '-' + position[2],
	      ref: position[0] + '-' + position[1] + '-' + position[2],
	      refInFor: true,
	      attrs: {
	        "position": position,
	        "id": position[0] + '-' + position[1] + '-' + position[2],
	        "opacity": _vm.opacity / 100
	      }
	    })
	  })])])
	},staticRenderFns: []}

/***/ },

/***/ 52:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    staticClass: "box",
	    style: (_vm.styleObject)
	  }, [_h('div', {
	    staticClass: "face",
	    style: ({
	      background: _vm.color.x3,
	      opacity: _vm.opacity
	    })
	  }), " ", _h('div', {
	    staticClass: "face",
	    style: ({
	      background: _vm.color.y3,
	      opacity: _vm.opacity
	    })
	  }), " ", _h('div', {
	    staticClass: "face",
	    style: ({
	      background: _vm.color.z1,
	      opacity: _vm.opacity
	    })
	  }), " ", _h('div', {
	    staticClass: "face",
	    style: ({
	      background: _vm.color.y1,
	      opacity: _vm.opacity
	    })
	  }), " ", _h('div', {
	    staticClass: "face",
	    style: ({
	      background: _vm.color.z3,
	      opacity: _vm.opacity
	    })
	  }), " ", _h('div', {
	    staticClass: "face",
	    style: ({
	      background: _vm.color.x1,
	      opacity: _vm.opacity
	    })
	  })])
	},staticRenderFns: []}

/***/ },

/***/ 53:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _h('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_h('CubeCore')])
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// static/js/app.e27b4e9324c58f97eddf.js